// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RqY4S","field":"styles_field__302cM","fieldCol":"styles_fieldCol__2fcW-","diffCol":"styles_diffCol__1o33X","diff":"styles_diff__39DYE"};